import React from 'react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
import { Star } from 'lucide-react';
export function Pricing() {
  return <section className="py-20 px-4 max-w-5xl mx-auto" data-id="element-172">
      <div className="text-center mb-12" data-id="element-173">
        <h2 className="text-2xl font-bold text-zinc-400 mb-6 flex items-center justify-center gap-2" data-id="element-174">
          <span data-id="element-175">⏰</span> PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>

        <div className="mb-8" data-id="element-176">
          <Countdown data-id="element-177" />
        </div>

        <div className="inline-block bg-red-500/10 border border-red-500/20 text-red-400 px-6 py-3 rounded-xl font-bold mb-8" data-id="element-178">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </div>

        <div className="max-w-md mx-auto mb-16" data-id="element-179">
          <div className="flex justify-between text-sm mb-2 font-bold" data-id="element-180">
            <span className="text-red-400 flex items-center gap-1" data-id="element-181">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-zinc-400" data-id="element-182">Quedan pocos</span>
          </div>
          <div className="h-3 bg-surface rounded-full overflow-hidden border border-zinc-800" data-id="element-183">
            <div className="h-full bg-red-500 w-[68%] rounded-full" data-id="element-184"></div>
          </div>
          <div className="text-xs text-zinc-500 mt-2 text-right" data-id="element-185">
            68% de los cupos ya tomados
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold mb-12" data-id="element-186">
          ELEGÍ TU COMBO COMPLETO
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-187">
        {/* Card 1 */}
        <div className="bg-surface border border-zinc-800 rounded-3xl p-8 flex flex-col relative" data-id="element-188">
          <div className="mb-6" data-id="element-189">
            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-190">
              <span data-id="element-191">📘</span> COMBO COMPLETO
            </h3>
            <p className="text-zinc-400 text-sm" data-id="element-192">6 Tomos + 6 Bonos</p>
          </div>

          <div className="bg-surface2 p-4 rounded-xl mb-6 text-sm text-zinc-300" data-id="element-193">
            <span className="font-bold text-white" data-id="element-194">Ideal para:</span> Profes que
            quieren resolver todo el año de clases con un sistema progresivo
            completo
          </div>

          <div className="mb-8 flex-grow" data-id="element-195">
            <div className="text-zinc-500 line-through text-xl font-bold mb-1" data-id="element-196">
              $51.000
            </div>
            <div className="text-5xl font-extrabold text-white mb-2" data-id="element-197">
              $19.990 <span className="text-2xl text-zinc-400" data-id="element-198">ARS</span>
            </div>
          </div>

          <Button fullWidth className="py-4 text-lg" data-id="element-199">
            → QUIERO MI COMBO COMPLETO
          </Button>
        </div>

        {/* Card 2 - Featured */}
        <div className="bg-surface border-2 border-primary rounded-3xl p-8 flex flex-col relative shadow-[0_0_30px_rgba(74,222,128,0.1)] transform md:-translate-y-4" data-id="element-200">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-black font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1" data-id="element-201">
            <Star className="w-4 h-4 fill-black" data-id="element-202" /> MÁS ELEGIDO
          </div>

          <div className="mb-6" data-id="element-203">
            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-204">
              <span data-id="element-205">🏆</span> COMBO + NEGOCIO
            </h3>
            <p className="text-zinc-400 text-sm" data-id="element-206">
              6 Tomos + 6 Bonos + Upsell Premium
            </p>
          </div>

          <div className="bg-primary/10 border border-primary/20 p-4 rounded-xl mb-6 text-sm text-zinc-300" data-id="element-207">
            <span className="font-bold text-white" data-id="element-208">Ideal para:</span> Profes que
            además quieren construir un negocio rentable, cobrar lo que valen y
            llenar sus grupos
          </div>

          <div className="mb-8 flex-grow" data-id="element-209">
            <div className="text-zinc-500 line-through text-xl font-bold mb-1" data-id="element-210">
              $76.000
            </div>
            <div className="text-5xl font-extrabold text-white mb-2" data-id="element-211">
              $27.990 <span className="text-2xl text-zinc-400" data-id="element-212">ARS</span>
            </div>
          </div>

          <Button fullWidth className="py-4 text-lg shadow-[0_0_20px_rgba(74,222,128,0.3)]" data-id="element-213">
            → QUIERO EL COMBO + NEGOCIO
          </Button>
        </div>
      </div>
    </section>;
}